query GetPotentialMatches(
  $sageJournalEntryId: ID!
  $limitByLegalEntity: Boolean
  $limitBySageGiftAccount: Boolean
  $limitByValue: Boolean
  $amountRange: Int
  $currencyMustMatch: Boolean
  $limitByDescription: Boolean
  $limitByDate: Boolean
  $dateRange: Int
  $includeCasesAlreadyMatched: Boolean
) {
  potentialMatches(
    sageJournalEntryId: $sageJournalEntryId
    limitByLegalEntity: $limitByLegalEntity
    limitBySageGiftAccount: $limitBySageGiftAccount
    limitByValue: $limitByValue
    amountRange: $amountRange
    currencyMustMatch: $currencyMustMatch
    limitByDescription: $limitByDescription
    limitByDate: $limitByDate
    dateRange: $dateRange
    includeCasesAlreadyMatched: $includeCasesAlreadyMatched
  ) {
    caseRecord {
      id
      caseNumber
      description
      transactionDate
      recipientAmountForRollUps {
        minorUnit
        currency
      }
      senderAmount {
        minorUnit
        currency
      }
      recipientFundAccount {
        id
        currency
        fund {
          id
          name
          legalEntity {
            id
            name
          }
        }
      }
      senderFundAccount {
        id
        currency
        fund {
          id
          name
          legalEntity {
            id
            name
          }
        }
      }
      caseType {
        id
        name
      }
      sageJournalEntries {
        id
        sageId
        description
      }
    }
    matches {
      type
      text
    }
    score
  }
}
